var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-field-alert"},[(_vm.title)?_c('strong',{staticClass:"list-field-alert__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('span',{staticClass:"list-field-alert__value"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }